module.exports = __webpack_public_path__ + "static/media/icn-share-20px.c04f80ce.svg";